import { render } from "./Tooltip.vue?vue&type=template&id=0ea27825&scoped=true"
import script from "./Tooltip.vue?vue&type=script&lang=js"
export * from "./Tooltip.vue?vue&type=script&lang=js"

import "./Tooltip.vue?vue&type=style&index=0&id=0ea27825&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ea27825"

export default script